import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Piece from './Piece';
import moment from 'moment';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import SinglePieceRow from './SinglePieceRow';
import SingleDetailRow from './SingleDetailRow';
import { getHomePieceId } from '../../store/actions/piece/piece.action';
import axiosService from '../../inits/axios';
import axios from 'axios';
import { get } from 'lodash';
import { Tabs, Tab } from 'react-bootstrap';
import PageLoader from '../../components/Common/PageLoader';
import TabComponent from '../Common/Tabs';

const ListPieces = ({
  pieceInfo,
  pieces_categories,
  homePieceMethods,
  editPiece,
  subscriptions,
  pieceSubscriptionMethods,
  getPiecesAddOns,
  mode
}) => {
  const [state, setState] = useState({
    data: pieceInfo.pieces,
    filteredData: pieceInfo.pieces,
    homePieceId: null,
    searchValue: '',
    sort: {
      column: 'title',
      direction: 'desc',
    },
    currentCategory: pieces_categories[0],
    initialFilterApplied: false,
    page: {
      count: 1,
      current: 1,
      size: 20,
      dataL: 1,
    },
    composers: [],
    eras: [],
    difficulties: [],
    subscriptions: [],
    instruments: [],
    artists: [],
    filterParams: {
      selectedComposer: '',
      selectedInstrument: '',
      selectedDifficulty: '',
      selectedOrder: '',
      selectedEra: '',
      selectedSubscription: '',
      selectedArtist: '',
    },
  });

  const onSort = useCallback((column, dir) => {
    let direction = 'asc';
    if (column === state.sort.column) {
      direction = state.sort.column ? (state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    }
    if (dir) {
      direction = dir;
    }

    const sortedData = [...state.filteredData].sort((a, b) => {
      const nameA = String(get(a, column) || '').toUpperCase();
      const nameB = String(get(b, column) || '').toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    if (direction === 'desc') {
      sortedData.reverse();
    }

    setState(prev => ({
      ...prev,
      filteredData: sortedData,
      sort: {
        column,
        direction: direction,
      },
    }));
  }, [state.sort, state.filteredData]);

  const getHomePiece = useCallback(() => {
    homePieceMethods.getHomePieceId();
  }, [homePieceMethods]);

  const setHomePiece = useCallback((piece_id) => {
    homePieceMethods.setHomePieceId({ piece_id });
  }, [homePieceMethods]);

  const getFilterElements = useCallback(async () => {
    try {
      const cdiInfo = await Promise.all([
        axiosService.get('/pieces/composers?order_by=name asc'),
        axiosService.get('/pieces/difficulties?order_by=name asc'),
        axiosService.get('/pieces/instruments?order_by=name asc'),
        axiosService.get('/pieces/eras?order_by=name asc'),
        axiosService.get('/subscriptions'),
        axiosService.get('/artists'),
      ]);

      setState(prev => ({
        ...prev,
        composers: cdiInfo[0],
        difficulties: cdiInfo[1].sort((a, b) => a.sequence - b.sequence),
        instruments: cdiInfo[2].sort((a, b) => a.sequence - b.sequence),
        eras: cdiInfo[3].sort((a, b) => a.sequence - b.sequence),
        subscriptions: cdiInfo[4].sort((a, b) => parseFloat(a.price) - parseFloat(b.price)),
        artists: cdiInfo[5].sort((a, b) => parseFloat(a.sequence) - parseFloat(b.sequence)),
        isLoading: false,
      }));
    } catch (err) {
      console.error('Error fetching filter elements:', err);
    }
  }, []);

  const updatePiece = useCallback((e, obj, orig) => {
    let pieces = JSON.parse(JSON.stringify(state.data));
    let latestCount = 0;
    let featuredCount = 0;

    pieces.forEach(({ featured, latest }) => {
      latestCount += latest;
      featuredCount += featured;
    });

    if (latestCount === 10 && obj['latest']) {
      toast.error(
        'Latest piece count reached 10. Please unselect one of the piece which is marked latest to mark this one.'
      );
      e.target.checked = !e.target.checked;
      return;
    }

    if (featuredCount === 10 && obj['featured']) {
      toast.error(
        'Featured piece count reached 10. Please unselect one of the piece which is marked featured to mark this one.'
      );
      e.target.checked = !e.target.checked;
      return;
    }

    pieces = pieces.map((piece) => {
      if (piece.id === obj.id) {
        if (obj['featured'] !== undefined) piece.featured = e.target.checked;
        if (obj['latest'] !== undefined) piece.latest = e.target.checked;
      }
      return piece;
    });

    editPiece(obj, orig);
    setState(prev => ({ ...prev, data: pieces }));
  }, [state.data, editPiece]);

  const handlePageChange = useCallback((current) => {
    setState(prev => ({
      ...prev,
      page: {
        ...prev.page,
        current,
      },
    }));
  }, []);

  const setFilter = useCallback((key) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    const value = e.target.value;
    setState(prev => ({
      ...prev,
      filterParams: {
        ...prev.filterParams,
        [key]: value,
      },
    }));
  }, []);

  const handleSearchChange = useCallback((e) => {
    setState(prev => ({ ...prev, searchValue: e.target.value }));
  }, []);

  const resetFilters = useCallback(() => {
    setState(prev => ({
      ...prev,
      searchValue: '',
      filterParams: {
        selectedComposer: '',
        selectedInstrument: '',
        selectedDifficulty: '',
        selectedOrder: '',
        selectedEra: '',
        selectedSubscription: '',
        selectedArtist: '',
      },
    }));
  }, []);

  const isFilterActive = useMemo(() => {
    const { filterParams, searchValue } = state;
    return Boolean(searchValue) || Object.values(filterParams).some((v) => Boolean(v));
  }, [state]);

  const handleState = useCallback((k, v) => {
    setState(prev => ({
      ...prev,
      [k]: v
    }));
  }, []);

  const applyFilters = useCallback(() => {
    const { filterParams, searchValue, data, currentCategory } = state;

    let filteredData = data.filter(
      ({ artist_id, composer_id, difficulty_id, era_id, instruments, subscriptions, category, title, description }) => {
        const matchesCategory = category === currentCategory;
        // Search title + description. Description is HTML — strip tags before matching.
        const haystack = `${String(title || '')} ${String(description || '').replace(/<[^>]*>/g, ' ')}`.toLowerCase();
        const matchesSearch = !searchValue || haystack.includes(searchValue.toLowerCase());
        // IDs are UUID strings (Go/Pop primary keys) — compare as strings, never parseInt.
        const matchesFilters = (
          (!filterParams.selectedArtist || artist_id === filterParams.selectedArtist) &&
          (!filterParams.selectedComposer || composer_id === filterParams.selectedComposer) &&
          (!filterParams.selectedDifficulty || difficulty_id === filterParams.selectedDifficulty) &&
          (!filterParams.selectedEra || era_id === filterParams.selectedEra) &&
          (!filterParams.selectedInstrument ||
            (instruments || []).some(({ instrument_id }) => instrument_id === filterParams.selectedInstrument)) &&
          (!filterParams.selectedSubscription ||
            (subscriptions || []).some(({ id }) => id === filterParams.selectedSubscription))
        );

        return matchesCategory && matchesSearch && matchesFilters;
      }
    );

    setState(prev => ({
      ...prev,
      filteredData,
      page: { ...prev.page, current: 1 }
    }));
  }, [state]);

  // Dropdown filters / category / data changes apply immediately.
  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filterParams, state.currentCategory, state.data]);

  // Free-text search is debounced: keeps the controlled input responsive and
  // avoids re-filtering 80+ rows + re-rendering the whole table on every keystroke
  // (which was dropping/scrambling characters under fast typing).
  useEffect(() => {
    const timer = setTimeout(() => applyFilters(), 250);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchValue]);

  useEffect(() => {
    if (JSON.stringify(pieceInfo.pieces) !== JSON.stringify(state.data)) {
      setState(prev => ({
        ...prev,
        data: pieceInfo.pieces,
        filteredData: pieceInfo.pieces
      }));
      onSort('title', 'asc');
    }
  }, [pieceInfo.pieces, state.data, onSort]);

  useEffect(() => {
    onSort('title');
    const boxBody = document.querySelector('#pieces .box-body');
    if (boxBody) {
      boxBody.classList.add('scaleFadeIn');
    }
    getHomePiece();
    getFilterElements();
  }, []);

  const renderFilters = useMemo(() => {
    const { eras, difficulties, composers, instruments, artists, subscriptions } = state;
    return (
      <React.Fragment>
        <input
          type="text"
          placeholder="Search pieces..."
          value={state.searchValue}
          onChange={handleSearchChange}
          className="search-input"
          style={{ marginRight: '10px', padding: '5px' }}
        />

        <select
          onChange={setFilter('selectedComposer')}
          className="composer-select"
          value={state.filterParams.selectedComposer}
        >
          <option value={''}>Composer</option>
          {composers.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </select>

        <select
          onChange={setFilter('selectedArtist')}
          className="artist-select"
          value={state.filterParams.selectedArtist}
        >
          <option value={''}>Artist</option>
          {artists.map((data) => (
            <option key={data.id} value={data.id}>
              {data.title}
            </option>
          ))}
        </select>

        <select
          onChange={setFilter('selectedDifficulty')}
          className="difficulty-select"
          value={state.filterParams.selectedDifficulty}
        >
          <option value={''}>Difficulty</option>
          {difficulties.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </select>

        <select
          onChange={setFilter('selectedEra')}
          className="era-select"
          value={state.filterParams.selectedEra}
        >
          <option value={''}>Era</option>
          {eras.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </select>

        <select
          onChange={setFilter('selectedInstrument')}
          className="era-select"
          value={state.filterParams.selectedInstrument}
        >
          <option value={''}>Instrument</option>
          {instruments.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </select>

        <select
          onChange={setFilter('selectedSubscription')}
          className="subscription-select"
          value={state.filterParams.selectedSubscription}
        >
          <option value={''}>Subscription</option>
          {subscriptions.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </select>

        <button
          type="button"
          onClick={resetFilters}
          disabled={!isFilterActive}
          className="cus-btn-primary"
          title="Clear all filters and search"
          style={{ marginLeft: '10px', padding: '5px 12px', opacity: isFilterActive ? 1 : 0.5 }}
        >
          Reset Filters
        </button>
      </React.Fragment>
    );
  }, [state, handleSearchChange, setFilter, resetFilters, isFilterActive]);

  const tabSwitch = useCallback((name) => {
    if (name === 'Details') {
      if (!(state.filteredData[0]?.interviews && state.filteredData[0]?.closeups)) {
        getPiecesAddOns();
      }
    }
  }, [state.filteredData, getPiecesAddOns]);

  const renderTableData = useCallback((results, isDetailTab = false) => {
    const { page } = state;
    const { deletePiece, getPieceByID } = pieceInfo;

    return (
      <tbody>
        {results.slice((page.current - 1) * page.size, page.current * page.size).map((piece, ind) => {
          if (isDetailTab) {
            return (
              <SingleDetailRow
                key={ind}
                page={page}
                piece={piece}
                ind={ind}
                methods={{ deletePiece, updatePiece, getPieceByID }}
                mode={mode}
              />
            );
          } else {
            return (
              <SinglePieceRow
                key={ind}
                ind={ind}
                page={page}
                piece={piece}
                subscriptions={subscriptions}
                methods={{ deletePiece, updatePiece, getPieceByID }}
                mode={mode}
                pieceSubscriptionMethods={pieceSubscriptionMethods}
              />
            );
          }
        })}
      </tbody>
    );
  }, [state.page, pieceInfo, updatePiece, mode, subscriptions, pieceSubscriptionMethods]);

  const singleTable = useCallback(() => {
    const { filteredData } = state;

    if (!state.initialFilterApplied) {
      setState(prev => ({
        ...prev,
        initialFilterApplied: true
      }));
      applyFilters();
    }

    return (
      <Tabs defaultActiveKey="Overview" transition={false} id="noanim-tab-example" onSelect={tabSwitch}>
        <Tab eventKey="Overview" title="Overview">
          <table className="table table-responsive table-hover">
            <thead>
              <tr>
                <th>S. No.</th>
                <th className="t-15" style={{ cursor: 'pointer' }} onClick={(e) => onSort('title')}>
                  Name {state.sort.column === 'title' ? '-' + state.sort.direction : ''}
                </th>
                <th className="t-25">Description</th>
                <th className="t-15">Product ID for Google</th>
                <th
                  className="t-15"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => onSort('composer.name')}
                >
                  Composer {state.sort.column === 'composer.name' ? '-' + state.sort.direction : ''}
                </th>
                <th
                  className="t-15"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => onSort('artist.title')}
                >
                  Artist {state.sort.column === 'artist.title' ? '-' + state.sort.direction : ''}
                </th>
                <th className="t-15">Subscriptions</th>
                <th className="t-10">Price</th>
                <th className="t-10">Latest ?</th>
                <th className="t-10">Featured ?</th>
                <th className="t-15">Action</th>
              </tr>
            </thead>
            {renderTableData(filteredData, false)}
          </table>
        </Tab>
        <Tab eventKey="Details" title="Details">
          <table className="table table-responsive table-hover">
            <thead>
              <tr>
                <th>S. No.</th>
                <th className="t-15">Name</th>
                <th className="t-25">Instruments</th>
                <th className="t-15">Videos</th>
                <th className="t-15">Interviews</th>
                <th className="t-15">Closeups</th>
                <th className="t-15">Action</th>
              </tr>
            </thead>
            {filteredData[0] && filteredData[0].interviews && filteredData[0].closeups ? (
              renderTableData(filteredData, true)
            ) : (
              <tbody>
                <tr>
                  <td colSpan="7">
                    <PageLoader />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </Tab>
      </Tabs>
    );
  }, [state, tabSwitch, onSort, renderTableData, applyFilters]);

  const { homePieceId } = homePieceMethods;
  const { pieces } = pieceInfo;
  const { page, filteredData } = state;

  return (
    <div
      id="pieces"
      className="box"
      onLoad={() => {
        const piecesElement = document.querySelector('#pieces');
        if (piecesElement) {
          piecesElement.classList.add('scaleFadeIn');
        }
      }}
    >
      <div className="box-header with-border">
        <h3 className="box-title">Pieces</h3>

        {mode === 'edit' && (
          <Link className="cus-btn-primary pull-right" to="/piece/create">
            Add Piece
          </Link>
        )}
      </div>
      <div className="search-cont">
        <div>
          <label>Home page piece</label>
          <br />
          {homePieceId && (
            <select value={homePieceId} onChange={(e) => setHomePiece(e.target.value)}>
              {pieces.map(({ id, title }) => {
                return (
                  <option key={id} value={id}>
                    {title}
                  </option>
                );
              })}
            </select>
          )}
        </div>
      </div>

      <div className="piece-filters">{renderFilters}</div>

      <Pagination
        current={page.current}
        total={filteredData.length}
        pageSize={page.size}
        showSizeChanger={false}
        onChange={handlePageChange}
        showQuickJumper={false}
        showTotal={(total, range) =>
          `${range[0]}-${range[1]} of ${total} pieces`
        }
      />

      <div className="box-body">
        <TabComponent
          titles={pieces_categories}
          components={pieces_categories.map((c) => singleTable(c))}
          setCurrentTab={(i) => handleState('currentCategory', pieces_categories[i])}
        />
      </div>

      <Pagination
        current={page.current}
        total={filteredData.length}
        pageSize={page.size}
        showSizeChanger={false}
        onChange={handlePageChange}
        showQuickJumper={false}
        showTotal={(total, range) =>
          `${range[0]}-${range[1]} of ${total} pieces`
        }
      />
    </div>
  );
};

export default ListPieces;
